import { computed } from 'vue'
/** This returns computed getter/setter logic needed for v-model logic. Defaults
 * to 'modelValue' but multiple named can be used in place.
 */
export const useModelWrapper = (props: any, emit: any, name = 'modelValue') => {
  return computed({
    get: () => props[name],
    set: (value) => emit(`update:${name}`, value),
  })
}
